import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Undo2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LaunchOfferRefundPanel = ({ token, onChanged }) => {
  const [form, setForm] = useState({ email: '', refund_reference: '', reason: '' });
  const [busy, setBusy] = useState(false);
  const [refunds, setRefunds] = useState([]);
  const headers = { Authorization: `Bearer ${token}` };

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/admin/campaigns/launch-offer/refunds`, { headers });
      setRefunds(data.refunds || []);
    } catch (error) {
      setRefunds([]);
    }
  }, [token]);

  useEffect(() => { load(); }, [load]);

  const submit = async (event) => {
    event.preventDefault();
    if (!window.confirm(`Retirer le cadeau de ${form.email} (remboursement ${form.refund_reference}) ? Cette action est définitive.`)) return;
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/admin/campaigns/launch-offer/revoke-refund`, form, { headers });
      toast[data.status === 'already_processed' ? 'info' : 'success'](
        data.status === 'already_processed' ? `Déjà traité : ${data.label}` : data.label
      );
      setForm({ email: '', refund_reference: '', reason: '' });
      await load();
      onChanged?.();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Le retrait du cadeau a échoué.');
    } finally {
      setBusy(false);
    }
  };

  const field = (key, placeholder, testId) => (
    <Input placeholder={placeholder} value={form[key]} required={key !== 'reason'} data-testid={testId}
      onChange={(e) => setForm({ ...form, [key]: e.target.value })} />
  );

  return (
    <div className="mt-4 rounded-md border border-zinc-700 bg-black/20 p-4" data-testid="launch-offer-refund-panel">
      <p className="mb-3 text-sm text-zinc-300">Remboursement : retire le cadeau non utilisé et libère la place. Si la course offerte a déjà été effectuée, la rémunération du chauffeur est conservée et le cas est signalé ci-dessous.</p>
      <form onSubmit={submit} className="grid gap-2 md:grid-cols-4">
        {field('email', 'Email de l’usager', 'refund-email-input')}
        {field('refund_reference', 'Référence du remboursement', 'refund-reference-input')}
        {field('reason', 'Motif (facultatif)', 'refund-reason-input')}
        <Button type="submit" disabled={busy} variant="outline" className="border-red-700/50 text-red-200 hover:bg-red-950/40" data-testid="launch-offer-revoke-refund-btn">
          <Undo2 className="mr-2 h-4 w-4" />{busy ? 'Traitement…' : 'Retirer le cadeau (remboursement)'}
        </Button>
      </form>
      {refunds.length > 0 && (
        <ul className="mt-3 space-y-1 text-xs text-zinc-400" data-testid="launch-offer-refund-list">
          {refunds.map((r) => (
            <li key={r.id}>{new Date(r.created_at).toLocaleString('fr-FR', { timeZone: 'Europe/Paris' })} — {r.email} — réf. {r.refund_reference} — <span className={r.outcome === 'ride_already_completed' ? 'text-amber-400' : 'text-zinc-200'}>{r.label}</span></li>
          ))}
        </ul>
      )}
    </div>
  );
};
